class ClaimRowLoader extends HTMLElement {
    public connectedCallback(): void {
        this.style.display = 'grid';
        this.style.gridColumn = '1 / -1';
        this.style.gridTemplateColumns = 'subgrid';
        this.style.height = '72px';
        this.style.gap = '1.5rem';
        this.style.padding = '0 0.75rem';
        this.style.alignItems = 'center';
        this.style.borderBottom = '1px solid #DDDDDD';
        this.render();
    }

    public render(): void {
        this.innerHTML = `
            <div class="react-loading-skeleton" style="width: 100%; height: 20px;"></div>
            <div class="react-loading-skeleton" style="width: 100%; height: 20px;"></div>
            <div class="react-loading-skeleton" style="width: 100%; height: 20px;"></div>
            <div class="react-loading-skeleton" style="width: 100%; height: 20px;"></div>
            <div class="react-loading-skeleton" style="width: 100%; height: 20px;"></div>
            <div class="react-loading-skeleton" style="width: 100%; height: 20px;"></div>
            <div class="react-loading-skeleton" style="width: 100%; height: 30px;"></div>
        `;
    }
}

// Register the custom element only if not already defined
if (!customElements.get('claim-row-loader')) {
    customElements.define('claim-row-loader', ClaimRowLoader);
}

export { ClaimRowLoader };
